var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import withWindowDimensions from '../../LsTofu/Constants/withWindowDimensions';
import DesktopNewHeader from './NewHeader/Desktop';
import MobileNewHeader from './NewHeader/Mobile';
import DesktopNavbar from './DesktopNavbar';
import MobNavbar from './MobNavbar';
var Navbar = function (_a) {
    var _b, _c;
    var buttons = _a.buttons, isLoggedIn = _a.isLoggedIn, navData = _a.navData, isMobileSized = _a.isMobileSized, mobileNavData = _a.mobileNavData, handleSegmentEvents = _a.handleSegmentEvents, logoLink = _a.logoLink, selectedTitle = _a.selectedTitle, isFixedHeader = _a.isFixedHeader, webHeaderWidth = _a.webHeaderWidth, isTabSized = _a.isTabSized;
    var _d = __read(useState(isLoggedIn), 2), isLoggedInLocal = _d[0], setIsLoggedInLocal = _d[1];
    useEffect(function () {
        setIsLoggedInLocal(isLoggedIn);
    }, [isLoggedIn]);
    if (isLoggedInLocal) {
        if (isMobileSized || isTabSized) {
            return (React.createElement(MobNavbar, { isLoggedIn: isLoggedInLocal, navData: navData, buttons: buttons, mobileNavData: mobileNavData, handleSegmentEvents: handleSegmentEvents, logoLink: logoLink, selectedTitle: selectedTitle }));
        }
        else {
            return (React.createElement(DesktopNavbar, { isLoggedIn: isLoggedInLocal, navData: navData, buttons: buttons, mobileNavData: mobileNavData, handleSegmentEvents: handleSegmentEvents, logoLink: logoLink, selectedTitle: selectedTitle }));
        }
    }
    if (!isLoggedInLocal) {
        if (isMobileSized || isTabSized) {
            return React.createElement(MobileNewHeader, { isFixedHeader: isFixedHeader, loginFunction: (_b = buttons[0]) === null || _b === void 0 ? void 0 : _b.handleClick });
        }
        else {
            return (React.createElement(DesktopNewHeader, { isFixedHeader: isFixedHeader, webHeaderWidth: webHeaderWidth, loginFunction: (_c = buttons[0]) === null || _c === void 0 ? void 0 : _c.handleClick }));
        }
    }
    return null;
};
export default withWindowDimensions(Navbar);
//# sourceMappingURL=index.js.map